// Mirrors PLATFORMS in electron-app/main.js so the dashboard can render
// the same set of tabs without round-tripping to the worker. Keep this in
// sync if you add a platform on the Electron side.

export interface PlatformDef {
  key: string;
  name: string;
  icon: string;
  color: string;
}

export const PLATFORMS: PlatformDef[] = [
  { key: "twitter",  name: "Twitter / X", icon: "𝕏",  color: "#1DA1F2" },
  { key: "fetlife",  name: "FetLife",     icon: "FL", color: "#e84040" },
  { key: "reddit",   name: "Reddit",      icon: "R",  color: "#FF4500" },
  { key: "redgifs",  name: "RedGifs",     icon: "RG", color: "#ff5c5c" },
  { key: "manyvids", name: "ManyVids",    icon: "MV", color: "#e040a0" },
  { key: "onlyfans", name: "OnlyFans",    icon: "OF", color: "#00AFF0" },
  { key: "fansly",   name: "Fansly",      icon: "Fy", color: "#1FA2F1" },
  { key: "gmail",    name: "Email",       icon: "✉",  color: "#EA4335" },
];
